<template>
  <div class="progress-container">
    <div class="progress-bar">
      <div class="progress-fill" 
        :style="{ width: clampedValue + '%' }"
      ></div>
      <span class="progress-text" :class="clampedValue>50?'whitetext':''">Ukończono {{ Math.round(clampedValue) }}%</span>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ProgressBar',
    props: {
        value: {
            type: Number,
            default: 0,
            validator: (value) => value >= 0 && value <= 100
        }
    },
    computed: {
        clampedValue() {
            // Zapewnia że wartość jest między 0 a 100
            return Math.max(0, Math.min(100, this.value));
        }
    }
}
</script>

<style scoped>
.progress-container {
  width: 100%;
  padding: 20px 0 10px 0;
}

.progress-bar {
  position: relative;
  width: 100%;
  height: 30px;
  background-color: var(--bs-progressbar-background);
  border: 0 none;
  border-radius: 10px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #00bce5;/*var(--bs-gradient-to);*/
    background-image: linear-gradient(to bottom, #00bce5, #02aace);

  transition: width 0.3s ease-in-out;
  border-radius: 10px;
}

.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 14px;
  color: #333;
  z-index: 1;
}

.progress-text.whitetext {
    /*color:white;
  transform: translate(-100%, -50%);*/

}
</style>